<template>
  <button
    @click="openModal"
    class="inline-flex items-center justify-center align-middle cursor-pointer hover:opacity-90 hover:scale-105 transition-all duration-200 focus:outline-none"
    :class="iconClass"
    aria-label="Play video"
    type="button"
  >
    <img 
      src="/images/play-button.png" 
      alt="Play video"
      :width="size" 
      :height="size"
      class="inline-block object-contain"
      style="display: inline-block;"
    />
  </button>
  
  <!-- Video Modal -->
  <VideoModal
    :isOpen="isModalOpen"
    :videoSrc="videoSrc"
    :poster="poster"
    @close="closeModal"
  />
</template>

<script setup>
import { ref } from 'vue';
import VideoModal from './VideoModal.vue';

const props = defineProps({
  videoSrc: {
    type: String,
    required: true
  },
  poster: {
    type: String,
    default: ''
  },
  size: {
    type: [Number, String],
    default: 24
  },
  circleColor: {
    type: String,
    default: '#00423D'
  },
  playColor: {
    type: String,
    default: '#FFFFFF'
  },
  iconClass: {
    type: String,
    default: ''
  }
});

const isModalOpen = ref(false);

const openModal = () => {
  isModalOpen.value = true;
};

const closeModal = () => {
  isModalOpen.value = false;
};
</script>

<style scoped>
</style>

